var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aspect-w-1 aspect-h-1 overflow-hidden cursor-pointer",on:{"click":_vm.onClick}},[_c('img',{staticClass:"w-full h-full object-cover rounded-lg border",attrs:{"src":_vm.mediaItem.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }